import React from 'react';
import styled from 'styled-components';
import { useWeather } from '../context/WeatherContext';

const Badge = styled.div`
  position: absolute;
  right: 2rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background: var(--deep-dark);
  border: 1px solid var(--gray-2);
  border-radius: 999px;
  padding: 0.4rem 1.2rem;
  font-family: 'RobotoMono Regular';
  font-size: 1.3rem;
  color: var(--gray-1);
  white-space: nowrap;
  user-select: none;
  .sep {
    color: var(--gray-2);
    font-size: 1rem;
  }
  /* Small tablet: hide condition label, keep only temp + emoji */
  @media only screen and (max-width: 900px) {
    .condition-label {
      display: none;
    }
  }
  /* Mobile: hide entirely */
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export default function WeatherBadge() {
  const data = useWeather();

  if (!data) return null;

  return (
    <Badge aria-label={`${data.temp}°C, ${data.label}`}>
      <span>🌡️ {data.temp}°C</span>
      <span className="sep">|</span>
      <span>{data.emoji} <span className="condition-label">{data.label}</span></span>
    </Badge>
  );
}
